export default __webpack_public_path__ + "static/media/settings.b409a4b2.svg";